import utils from '../utils'
import apiClient from './AxiosHttp'


const confirmPayment = (checkoutId) => {
    return apiClient.get(`/payments/confirm/${checkoutId}/`)
}

const createCustomer = (details) => {
    return apiClient.post(`/payments/create/customer/`, details)
}

const requestCartPayment = (details) => {
    return apiClient.post(`/payments/cart/request/`, details)
}

const updatePayment = (id, details) => {
    return apiClient.patch(`/payments/fetch/${id}/`, details)
}

const getPurchases = (params) => {
    return apiClient.get(`/payments/list/${params}`,)
}

const mpesaSTK = (details) => {
    return apiClient.post('/payments/mpesa/stk-push/', details)
}

const createRefund = (details) => {
    return apiClient.post(
        `/payments/refunds/`, 
        details,
        { headers: utils.multipartHeader }
    )
}

const getRefunds = (params) => {
    return apiClient.get(`/payments/refunds/${params}`)
}

const getSpecificRefund = (id) => {
    return apiClient.get(`/payments/refunds/get/${id}/`)
}

const paymentsStats = () => {
    return apiClient.get(`/payments/metrics/payments/`)
}

const refundsStats = () => {
    return apiClient.get(`/payments/metrics/refunds/`)
}

const reconfirmPayment = (txRef) => {
    return apiClient.get(`/payments/reconfirmation/${txRef}/`)
}

const confirmDelivery = (details) => {
    return apiClient.post(
        `/payments/delivery/confirm/`, 
        details,
    )
}

const paymentsService = {
    confirmPayment,
    createCustomer,
    requestCartPayment,
    updatePayment,
    getPurchases,
    createRefund,
    getRefunds,
    getSpecificRefund,
    paymentsStats,
    refundsStats,
    reconfirmPayment,
    confirmDelivery,
    mpesaSTK,
}

export default paymentsService